import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import CustomizedTab from "../../../components/Custom/CustomizedTab";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import PurchaseReturnTable from "../../../components/Table/Purchase/Return";

import { IBreadcrumbsAndMenu, IMenuOption, ITab } from "../../../types/global";
import CustomizedMenuOptions from "../../../components/Custom/CustomizedMenuOptions";
import { branchInfoFromSessionStorage } from "../../../utils/Global";
import { useModal } from "../../../hooks/use-modal";
import ExporterPurchaseModal from "../../../components/UI/Modal/ExporterPurchaseModal";
import { PurchaseExportType } from "../../../generated/purchase";

const PurchaseReturn = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isFilter = searchParams.get("filter");
  const { is_hq } = branchInfoFromSessionStorage();

  const { modal, openModalHandler, closeModalHandler } = useModal();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("purchase.index"),
      to: "/purchase",
    },
    {
      name: t("purchase.return.index"),
    },
  ];

  const tabs: ITab[] = [
    {
      label: t("status.all"),
      path: `${pathname}`,
    },
    {
      label: t("status.draft"),
      path: `${pathname}?filter=draft`,
    },
    {
      label: t("status.wait_approve"),
      path: `${pathname}?filter=wait_approve`,
    },
    {
      label: t("status.not_approved"),
      path: `${pathname}?filter=not_approved`,
    },
    {
      label: t("status.approved"),
      path: `${pathname}?filter=approved`,
    },
    {
      label: t("status.cancelled"),
      path: `${pathname}?filter=cancelled`,
    },
  ];

  const currentTab = pathname + (isFilter ? `?filter=${isFilter}` : "");

  const options: IMenuOption[] = [
    {
      value: t("purchase.export"),
    },
  ];

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 3 }}>
        <Typography variant="h5">{t("purchase.return.index")}</Typography>
        <Box display="flex" gap={1}>
          {is_hq === "true" && (
            <CustomizedMenuOptions
              isIcon
              options={options}
              onSelect={(e) => {
                const value = e.target as HTMLElement;
                switch (value.innerText) {
                  case `${t("purchase.export")}`:
                    openModalHandler();
                    break;
                  default:
                }
              }}
            />
          )}
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <CustomizedTab tabs={tabs} currentTab={currentTab} divider table />
      </Box>
      <PurchaseReturnTable isFilter={isFilter} />
      <ExporterPurchaseModal
        open={modal}
        closeModalHandler={closeModalHandler}
        documentType={PurchaseExportType.PurchaseReturn}
      />
    </>
  );
};

export default PurchaseReturn;
